import Point from './Point';
import Angle from './Angle';
import Color from '../utils/Color';

export default class PieSlice {
  color = Color.BLACK;

  root = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  };

  _startAngle = new Angle(0);
  arcRadians = 0;
  clockwise = false;

  get alpha() {
    return this.color.getAlpha();
  }

  set alpha(value) {
    this.color.setAlpha(value);
  }

  set startRadians(radians) {
    this._startAngle = new Angle(radians);
  }

  asPolygon() {
    const angle = this.clockwise
      ? this._startAngle.minus(new Angle(this.arcRadians))
      : this._startAngle.plus(new Angle(this.arcRadians));
    const { x, y, width, height } = this.root;

    const corners = [
      new Point(x, y),
      new Point(x, y + height),
      new Point(x + width, y + height),
      new Point(x + width, y),
    ];

    corners.sort((a, b) =>
      this.clockwise
        ? this._startAngle.minus(a.angle).radians -
          this._startAngle.minus(b.angle).radians
        : a.angle.minus(this._startAngle).radians -
          b.angle.minus(this._startAngle).radians
    );

    const points = [
      new Point(0, 0),
      this._startAngle.project(corners[corners.length - 1], corners[0]),
    ];

    for (const corner of corners) {
      const cornerRelativeAngle = this.clockwise
        ? this._startAngle.minus(corner.angle)
        : corner.angle.minus(this._startAngle);
      if (cornerRelativeAngle.radians >= this.arcRadians) {
        points.push(angle.project(points[points.length - 1], corner));
        return points;
      }
      points.push(corner);
    }

    points.push(angle.project(corners[corners.length - 1], corners[0]));
    return points;
  }

  draw(graphics) {
    if (this.arcRadians === 0) {
      return;
    }

    graphics.beginFill(Color.toNumber(this.color), this.color.getAlpha());
    graphics.drawPolygon(this.asPolygon());
    graphics.endFill();
  }
}
